import "./GetQuote.module.css";
import AcostasLandscaping from "@/reusable_sections/Header";
import StartYourTransformation from "./sections/StartYourTransformation";
import DirectReach from "./sections/DirectReach";
import CommonQuestions from "./sections/CommonQuestions";
import SiteFooter from "@/reusable_sections/Footer";
export default function GetQuotePage() {
  return <div>
      <AcostasLandscaping />
      <StartYourTransformation />
      <DirectReach />
      <CommonQuestions />
      <SiteFooter />
    </div>;
}